var map = {
	"./73219336.jpeg": 67,
	"./CDAC-logo.webp": 130,
	"./IMG_20240527_180148.png": 65,
	"./address_image.svg": 131,
	"./animated_ashutosh.png": 132,
	"./animated_logo.svg": 133,
	"./blogs_image.svg": 134,
	"./cloud_infrastructure.svg": 135,
	"./codeInLogo.png": 136,
	"./contactMail.png": 137,
	"./coursera_logo.png": 138,
	"./data_science.svg": 139,
	"./deeplearning_ai_logo.png": 140,
	"./delhivery_logo.png": 141,
	"./developerActivity.svg": 142,
	"./dsc_logo.png": 143,
	"./education.svg": 144,
	"./experience.svg": 145,
	"./feelingProud.svg": 146,
	"./freecopy_logo.png": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./iacsd-logo.png": 154,
	"./ibm_logo.png": 155,
	"./iiitk_logo.png": 156,
	"./intel_logo.jpg": 157,
	"./iu_logo.png": 158,
	"./jsFramework.svg": 159,
	"./legato_logo.png": 160,
	"./manOnTable.svg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./nextuLogo.jpg": 165,
	"./nptel_logo.png": 166,
	"./portfolio.gif": 167,
	"./programmer.svg": 168,
	"./projects_image.svg": 169,
	"./pwa.png": 170,
	"./rgi_logo1.png": 171,
	"./saayaHealthLogo.png": 172,
	"./stanford_logo.png": 173,
	"./talksCardBack.svg": 174,
	"./talksCardBackAlt.svg": 175,
	"./tcsIon_logo.jpg": 176,
	"./tiktok_logo.png": 177,
	"./ui_ux_design.svg": 178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;